import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, FeedbackBanner } from '@usacow/ds';
import type { DrillKind } from '@usacow/drills';
import { api } from '../lib/api';
import { DrillSession } from '../components/DrillSession';

const SKILL_LABEL: Record<string, string> = {
  parsing: 'Parsing',
  modeling: 'Modeling',
  algorithm_choice: 'Algorithm choice',
  execution: 'Execution',
  proof: 'Proof',
  implementation: 'Implementation',
  retention: 'Retention',
};

export function Repair() {
  const navigate = useNavigate();
  const [data, setData] = useState<{ weakSkill: string; slots: string[] } | null>(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    api
      .getRepair()
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) return <div className="route-loading">Loading…</div>;

  return (
    <div className="scr scr--narrow">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">weakness repair</div>
          <h1 className="scr-h">{SKILL_LABEL[data.weakSkill] ?? data.weakSkill}</h1>
        </div>
      </div>
      {!started ? (
        <>
          <FeedbackBanner state="warning" title="Why this is flagged">
            This is your lowest-scoring reasoning skill right now. This session isolates it with
            targeted drills until your accuracy climbs.
          </FeedbackBanner>
          <Button
            variant="primary"
            size="lg"
            style={{ marginTop: 16 }}
            onClick={() => setStarted(true)}
          >
            Start repair
          </Button>
        </>
      ) : (
        <DrillSession slots={data.slots as DrillKind[]} onDone={() => navigate('/app')} />
      )}
    </div>
  );
}
